<div class="fixed inset-0 z-[9999] flex items-center justify-center bg-white p-6" role="alert" aria-live="polite">
    <div class="w-full max-w-md">
        <div class="p-6 text-center bg-white border border-gray-100 shadow-xl rounded-2xl pop-in">

            <div class="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14" [ngClass]="badgeClass">
                <svg *ngIf="iconType === 'lock'" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>

                <svg *ngIf="iconType === 'shield'" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                    <path d="M12 8v4" />
                    <path d="M12 16h.01" />
                </svg>

                <svg *ngIf="iconType === 'search'" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                </svg>

                <svg *ngIf="iconType === 'server'" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                    </path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>

                <svg *ngIf="iconType === 'help'" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
            </div>

            <h1 class="font-heading text-xl md:text-2xl font-bold text-primary">
                {{ title }}
            </h1>

            <p class="mt-2 text-sm text-gray-600 leading-relaxed">
                {{ subtitle }}
            </p>

            <p *ngIf="detail" class="mt-2 text-xs text-gray-400 break-all bg-gray-50 py-1 px-2 rounded">
                {{ detail }}
            </p>

            <button type="button" (click)="goAction(action)"
                class="w-full mt-6 px-4 py-2.5 rounded-lg bg-primary text-white text-sm font-semibold hover:opacity-95 transition active:scale-[0.99] focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
                {{ primaryText }}
            </button>

            <button *ngIf="secondaryText" type="button" (click)="goAction(secondaryAction)"
                class="w-full px-4 py-2.5 mt-3 text-sm font-semibold text-primary transition border border-primary rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
                {{ secondaryText }}
            </button>

            <p class="mt-5 text-[11px] text-gray-400">
                Jika merasa ini kesalahan, hubungi admin untuk bantuan
            </p>
        </div>
    </div>
</div>